import { noop } from 'lodash';
import React from 'react';

import type { HGClubMemberOptions } from '@swf/generated/types/api/v0/SwHomeGames';

export interface ClubContextState {
  settings: HGClubMemberOptions;
}

export interface ContextProvider {
  state: ClubContextState;
  setState: React.Dispatch<React.SetStateAction<ClubContextState>>;
}

export const initialState = {
  settings: {
    blockClubMail: false,
    clubOnlineStyle: false,
    showClubActiveTables: false,
    showRealName: false
  }
};

const ClubContext = React.createContext<ContextProvider>({
  state: initialState,
  setState: () => noop
});

export default ClubContext;
